// Global
import { Form } from 'antd';
import { FormListProps } from 'antd/es/form';
import { FC } from 'react';

// Components
import { UpdateContentTextEditorBlock } from '../../formBlocks/UpdateTextEditorBlock';
import { VariableType } from 'src/shared/ui/VariablesDetector/VariableDetector.typedefs';

interface UpdateTextEditorBlocksFormListProps {
  fieldName: FormListProps['name'];
  registerInputRef: (fieldName: string, ref: any, type: VariableType) => void;
  handleInputChange: (fieldName: string, value: string) => void;
}

export const UpdateTextEditorBlocksFormList: FC<UpdateTextEditorBlocksFormListProps> = ({
  fieldName,
  registerInputRef,
  handleInputChange,
}) => {
  return (
    <Form.List name={fieldName}>
      {(fields) =>
        fields.map((field) => (
          <UpdateContentTextEditorBlock
            registerInputRef={registerInputRef}
            handleInputChange={handleInputChange}
            key={field.key}
            fieldName={field.name}
          />
        ))
      }
    </Form.List>
  );
};
